import { useProductPageStore } from '../../contexts/ProductPageStore'
import styles from './asideRecommendations.module.scss'

import React, { useContext, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import { useUserStore } from 'Clutch/Stores/UserStore/UserStore'
import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'
import Image from 'next/image'

import { getSuperMarketAffinity } from 'Clutch/Utilities/Instrumentation/SegmentUtilities/segmentFunctions'

import { TrackingContext } from 'Clutch/Contexts/TrackingContext/TrackingContext'

import Card from 'Clutch/Atoms/Card'
import Divider from 'Clutch/Atoms/Divider'
import Rating from 'Clutch/Atoms/Rating'
import TextLink from 'Clutch/Atoms/TextLink'
import Typography from 'Clutch/Atoms/Typography'

const AlternateRecommendations = ({}) => {
  const alternativeProducts = useProductPageStore((x) => x.alternativeProducts)
  const availability = useProductPageStore((x) => x.availability)
  const userVin = useUserStore((x) => x.context.userVin)
  const userGuid = useUserStore((x) => x.context.userGuid)

  const { segmentReady } = useContext(TrackingContext)

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
    rootMargin: '0px 0px', //because this doesn't initiate a request
  })

  const title = 'Get something sooner'

  useEffect(() => {
    if (inView) {
      //send segment product list viewed
      //this feeds miso recommendation impressions
      if (segmentReady && (alternativeProducts || []).length > 0) {
        try {
          analytics.track('Product List Viewed', {
            user_vin: `${userVin()}`,
            web_user_guid: `${userGuid}`,
            list_id: `pdp_aside_alts_0`,
            category: `${title}`,
            products: (alternativeProducts || []).map((alt, i) => {
              return {
                product_id: alt.skuBaseNumber,
                sku: alt.skuBaseNumber,
                name: alt.title,
                price: alt.price,
                position: i,
                category: alt.segmentCategorization,
                url: alt.productPageUrl,
                image_url: alt.imageUrl,
                quantity: 1,
                brand: alt.brand,
                availability: alt.availability,
                rating: alt.reviewCount ? alt.rating : 0,
                reviews: alt.reviewCount,
                audience_affinity: getSuperMarketAffinity(alt),
              }
            }),
          })
        } catch (err) {
          console.error(err)
        }
      } else {
        console.info('analytics not defined')
      }
    }
  }, [inView, segmentReady])

  if (!(alternativeProducts || []).length) return false

  if (!(availability == 'On Backorder' || availability == 'Factory Shipped' || availability == 'Discontinued'))
    return false

  return (
    <ErrorBoundary>
      <div id={'pdp_alternates'} className={styles.pdp_aside_cards} ref={ref}>
        <Card fill>
          <Typography className={styles.header} size={1.25} as={'h2'} font={'heading'}>
            {title}
          </Typography>
          <Typography className={styles.description} size={0.875}>
            In Stock and Ready to Ship
          </Typography>
          <Typography size={0.875}>
            {`${alternativeProducts.length} ${alternativeProducts.length === 1 ? 'item' : 'items'}`}
          </Typography>
          <Divider className={styles.divider} />
          {alternativeProducts.map((alternativeProduct, index) => (
            <div className={styles.rec_wrapper} key={`alt_prod_${alternativeProduct.skuBaseNumber}_${index}`}>
              <TextLink as={'div'} className={styles.rec_image_wrapper} href={alternativeProduct.productPageUrl}>
                <Image
                  src={`https:${alternativeProduct.imageUrl ? alternativeProduct.imageUrl : '//content.speedwaymotors.com/OtherImages/missingimage2.jpg'}`}
                  width={124}
                  height={124}
                />
              </TextLink>
              <span>
                <TextLink size={1} href={alternativeProduct.productPageUrl}>
                  {alternativeProduct.title}
                </TextLink>
                <Rating ratingValue={alternativeProduct.rating} />
                <Typography size={1} font={'bold'}>
                  {alternativeProduct.priceString}
                </Typography>
              </span>
            </div>
          ))}
        </Card>
      </div>
    </ErrorBoundary>
  )
}

export default AlternateRecommendations
